export default "__VITE_ASSET__dc764028__"